export const POSITION_SLOT_STATUS = {
  PENDING: 'PENDING',
  OPEN: 'OPEN',
  FILLED: 'FILLED',
  ARCHIVED: 'ARCHIVED',
} as const;

export const POSITION_SLOT_WORKER_TYPE = {
  STAFF: 'STAFF',
  CONTRACTOR: 'CONTRACTOR',
  EXCEPTION: 'EXCEPTION',
} as const;

export const POSITION_SLOT_LIFECYCLE = {
  ACTIVE: 'ACTIVE',
  FROZEN: 'FROZEN',
  RETIRED: 'RETIRED',
} as const;

export const POSITION_SLOT_OCCUPANCY = {
  VACANT: 'VACANT',
  OCCUPIED: 'OCCUPIED',
} as const;

export const POSITION_SLOTS_PATH = '/position-slots';

export type PositionSlotWorkerType = (typeof POSITION_SLOT_WORKER_TYPE)[keyof typeof POSITION_SLOT_WORKER_TYPE];

export type PositionSlotLifecycle = (typeof POSITION_SLOT_LIFECYCLE)[keyof typeof POSITION_SLOT_LIFECYCLE];

export type PositionSlotOccupancy = (typeof POSITION_SLOT_OCCUPANCY)[keyof typeof POSITION_SLOT_OCCUPANCY];

export const POSITION_SLOT_WORKER_TYPE_LABELS: Dictionary<string> = {
  [POSITION_SLOT_WORKER_TYPE.STAFF]: 'Staff',
  [POSITION_SLOT_WORKER_TYPE.CONTRACTOR]: 'Contractor',
  [POSITION_SLOT_WORKER_TYPE.EXCEPTION]: 'Exception',
};

export const POSITION_SLOT_SECONDARY_COMPETENCY_LEVELS = {
  L1: 'L1',
  L2: 'L2',
  L3: 'L3',
  L4: 'L4',
} as const;
